// ----------------------------------------------------------------------

export default function Switch(theme) {
  return {
    MuiSwitch: {
      styleOverrides: {
        root: {
          width: 52,
          height: 28,
          padding: 0,
          margin: theme.spacing(1),
          '& .MuiSwitch-switchBase': {
            padding: 3,
            '&.Mui-checked': {
              transform: 'translateX(24px)',
              color: theme.palette.common.white,
              '& + .MuiSwitch-track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
                border: 'none',
              },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
              color: theme.palette.primary.main,
              border: `2px solid ${theme.palette.background.paper}`,
            },
          },
          '& .MuiSwitch-thumb': {
            width: 22,
            height: 22,
          },
          '& .MuiSwitch-track': {
            borderRadius: 23,
            backgroundColor: '#fff',
            opacity: 1,
            transition: theme.transitions.create(['background-color', 'border']),
            border: `1px solid ${theme.palette.grey[500]}`,
          },
        },
        switchBase: {
          color: theme.palette.grey[500],
          '&$checked': {
            color: theme.palette.grey[500],
          },
          '&$checked + $track': {
            backgroundColor: theme.palette.primary.main,
          },
        },
        checked: {},
        track: {},
      },
    },
  };
}
